import React, { useEffect, useState, useRef } from "react";
import "../styles.css";
import "bootstrap/dist/css/bootstrap.css";
import "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setBackfromCampaign } from "ReduxStore/Slices/campaignSlice";
import {
  setTemplateName,
  setTemplateType,
  setTemplateDescription,
  setBackFromAllTemplates,
  resetTemplateData,
} from "ReduxStore/Slices/templateSlice";
import { setUserFlow } from "ReduxStore/Slices/userSlice";
import { getTemplateInfoById } from "api/TemaplateApi";
import SupportLink from "../Common/SupportLink";

function CreateTemplateInfo(props) {
  const templateNameRef = useRef();
  const templateDesciptionRef = useRef();
  const templateTypeRef = useRef();
  const dispatch = useDispatch();
  const {
    templateName,
    templateType,
    templateDescription,
    templateParameterId,
    backFromAllTemplates,
  } = useSelector((state) => state.templateSetter);
  dispatch(setBackfromCampaign(false));
  const { role } = useSelector(
    (state) => state.userSetter
  );
  const routeChangetonext = (name, description) => {
    let path = `/admin/templates/select`;
    let pathWeb = `/admin/templates/select-web`;
    // if (templateTypeRef.current.value == "email") {
    //   props.history.push(path);
    // } else {
    //   props.history.push(pathWeb);
    // }
    props.history.push(path);

  };
  function getTemplateInfo() {
    getTemplateInfoById(templateParameterId)
      .then((data) => {
        dispatch(setTemplateName(data.name));
        dispatch(setTemplateDescription(data.description));
        dispatch(setTemplateType(data.type));
        templateNameRef.current.value = data.name;
        templateDesciptionRef.current.value = data.description;
        templateTypeRef.current.value = data.type;
      })
      .catch((err) => {

      });
  }

  const routeChangetocancel = (e) => {
    e.preventDefault();
    dispatch(setBackFromAllTemplates(false));
    dispatch(resetTemplateData());
  };

  useEffect(() => {
    dispatch(setUserFlow("createTemplate"));

    if (backFromAllTemplates) {
      getTemplateInfo();
    }
  }, [templateType, backFromAllTemplates]);

  return (
    <div>
      <SupportLink link='https://kapitalwise.com/user-guide/content/#create_template' />

      <div className="page_heading">
        <h2>Create Template</h2>
      </div>
      <form
        // ref={Formref}
        onSubmit={() => routeChangetonext()}
      >
        <div className="audieneOuter">
          <div
            className="inputOuter"
            style={{ display: "flex", flexDirection: "row" }}
          >
            <div>
              <label className="large">Template Name </label>
              <input
                id="audienceName"
                type="text"
                className="kwDesign max351"
                required
                value={templateName}
                onChange={(e) => {
                  dispatch(setTemplateName(e.target.value));
                }}
                ref={templateNameRef}
              />
            </div>
            <div style={{ marginLeft: 50 }}>
              <label className="large">Select Type</label>
              <div>
                <select
                  id="selectSubscribtion"
                  className="kwDesign2 w486"
                  ref={templateTypeRef}
                  value={templateType}
                  required
                  disabled={backFromAllTemplates ? true : false}
                  onChange={(e) => {
                    dispatch(setTemplateType(e.target.value));
                  }}

                >
                  <option value="">Select</option>
                  <option value="publishedContent">Web Page</option>
                  {role !='publisher'&&<option value="email">Email</option>}
                </select>
              </div>
            </div>
          </div>
          <div className="inputOuter">
            <label className="large">Description</label>
            <textarea
              id="textArea"
              className="csTextarea"
              required
              ref={templateDesciptionRef}
              value={templateDescription}
              onChange={(e) => {
                dispatch(setTemplateDescription(e.target.value));
              }}
            ></textarea>
          </div>

          <div className="previewAudience">
            <input type="submit" className="lg_btn primary mb-2" value="Next" />{" "}
            &nbsp;&nbsp;
            <a
              onClick={routeChangetocancel}
              className="lg_btn tertiary"
              type="reset"
            >
              Cancel
            </a>
          </div>
        </div>
      </form>
    </div>
  );
}

export default CreateTemplateInfo;
